export const DEFAULT_EMPTY_VALUE = '-';
export const SAFE_DISPLAY_ALLOWED_SPECIAL_CHARACTERS = '- _ . , & ( )';
export const DEFAULT_DRAWER_WIDTH = 600;
export const DEFAULT_ACTIONS_COLUMN_WIDTH = 60;
export const TABLE_ACTIONS_INLINE_EXTRA_PER_ACTION_PX = 20;
